import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { ProcedureInitiativeDetailViewTopBar } from "./TopBar"

export const procedureInitiativeDetailViewStaticData: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: ProcedureInitiativeDetailViewTopBar,
}
